//Created as 2 separate files for header and footer to create chunks of them for faster loading

import React from "react";
import { createRoot } from "react-dom";
import { Footer } from "./components/Footer";

document.addEventListener("DOMContentLoaded", () => {
  // Render Footer
  const mountNode2 = document.getElementById("react-footer");
  if (mountNode2) {
    const root2 = createRoot(mountNode2);
    root2.render(<Footer />);
  }
});
